module.controller('cardRegisterCtrl', ['$rootScope', '$scope', '$state', '$stateParams', 'baseURI', '$http', 'Transform', '$window', '$timeout', 'SECURITY_QUESTIONS', 'checkEmailService', 'brandService', 'LimitsService', 'authService', '$q', 'SigmaDeviceRiskService', 'countryCodes', 'Session', function($rootScope, $scope, $state, $stateParams, baseURI, $http, Transform, $window, $timeout, SECURITY_QUESTIONS, checkEmailService, brandService, LimitsService, authService, $q, SigmaDeviceRiskService, countryCodes, Session) {
  $scope.showValidateEmail = false;
  $scope.submitted = false;
  $scope.ssnInputType = 'password';
  $scope.passwordInputType = 'password';
  $scope.questions = SECURITY_QUESTIONS;
  $scope.brand = brandService.getBrand($stateParams.brand);
  $scope.registrationVersion = $stateParams.v;
  $scope.formData.nra = 'Y';
  $scope.showUsioTos = $scope.brand.name === 'nowincentive' || $scope.brand.name === 'nowpromo' || $scope.brand.name === 'prosperikey';
  $scope.latestAgeYear = new Date().getFullYear() - 18;

  var countries = [];
  for (var code in countryCodes.codeToCountry) {
    if (countryCodes.codeToCountry.hasOwnProperty(code)) {
      countries.push({
        code: code,
        name: countryCodes.codeToCountry[code]
      });
    }
  }
  $scope.countries = countries;

  var sessionId;
  var onSuccess = function(Id){
    sessionId = Id;
  };
  var onError = function() {
    console.catch("Socure Device Risk Response Error");
  };
  SigmaDeviceRiskService.getSessionToken(onSuccess, onError);


  $scope.attemptNextStep = function(registerForm, next){
    if(!registerForm.$valid){
      $scope.submitted = true;
    } else {
      if(next == 'root.register.esignDisclosure'){
        getRegistrationType();
      } else {
        $state.go(next);
      }
    }
  };

  $scope.attemptSubmission = function(registerForm){
    if(!registerForm.$valid){
      $scope.submitted = true;
    } else {
      if($scope.validation.RegistrationType == 'login'){
        registerSub();
      } else {
        registerCard();
      }
    }
  };

  var goToSuccessPage = function(message) {
    $state.go('root.register.success', {
      successMessage: message,
      credentials: {
        username: $scope.formData.email,
        password: $scope.formData.password,
        brand: $scope.brand.name,
        _key: $scope.brand.api_key
      }
    });
  };

  var goToLoginSuccessPage = function(message) {
    $state.go('root.redeem.success', {
      successMessage: message,
      username: $scope.formData.email,
    });
  };

  $scope.goToDashboard = function(registerRespData){
    var oauth = JSON.parse(registerRespData.Data.OAuthData);
    var token = oauth.access_token;

    Session.setToken(token);
    Session.setUsername(registerRespData.Data.Username);

    $q.all([
      authService.devicePost($scope.formData.VerificationCode),
      authService.checkStatus(),
      authService.getFeatureAccess(),
      LimitsService.update()
    ]).then(function(results){
      // set status and feature access
      authService.setStatusSession(results[1].data);
      authService.setFeatureAccessSession(results[2].data);

      // If signup is complete, direct CH to dashboard
      authService.injectUserToDashboard();

    }).catch(function(err){
      handleError(err);
    });
  };

  // display error messaging during login
  var handleError = function (error){
    $scope.loading = false;
    $scope.displayMessage = true;

    // 403 errors
    if(error.status === 403 && error.data.ErrorCode){
      switch(error.data.ErrorCode){
        case 150:
          //if the user needs to go through the Jumio KYC process in the dashboard

          $q.all([
            authService.checkStatus(),
            authService.getFeatureAccess(),
            LimitsService.update()
          ]).then(function(results){

            // set status and feature access
            authService.setStatusSession(results[0].data);
            authService.setFeatureAccessSession(results[1].data);

            // If signup is complete, direct CH to dashboard
            authService.injectUserToDashboard();

          }).catch(function(err){
            $scope.alertError.show = true;
            $scope.alertError.message = "Oops! Something went wrong on our end. Please try again.";      });
          break;
        default:
          $scope.alertError.show = true;
          $scope.alertError.message = "Oops! Something went wrong on our end. Please try again.";
          break;
      }
    }
    // 502 errors
    if(error.status === 502){
      $scope.alertError.message = 'Oops ' + $scope.brand.programName + ' is experiencing connectivity issues, please try again in a bit.';
    }
    // 401 and 400 errors
    if(error.status === 401 || error.status === 400){
      $scope.alertError.message = 'Invalid username or password provided.';
    }
  };

  var initialEmail = '';

  // check CH email using check email service
  $scope.checkEmail = function(email){
    // Don't POST if email is unchanged
    if (initialEmail !== email || $scope.joinForm.email.networkError) {
      $scope.joinForm.email.networkError = false;
      initialEmail = email;
      if (email) {
        checkEmailService.validate(email, function(isEmailValid, error){
          if (error) {
            $scope.joinForm.email.networkError = error;
          } else {
            $scope.joinForm.email.$setValidity('unique', isEmailValid);
          }
        });
      }
    }
  };

  var getRegistrationType = function(){
    $scope.parent.fullOverlayLoading = true;

    var request = defineRequest();

    $http({
      url: baseURI + 'card/register',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function(resp){
      var data = resp.data;

      $scope.parent.fullOverlayLoading = false;
      if(data.Success){
        if(data.Data.RegistrationType === ''){
          $scope.alertError.message = 'Oops, this card has already been registered. Please try logging in.';
          $scope.alertError.resetPassword = true;
          $scope.alertError.show = true;
        } else {
          $scope.validation.RegistrationType = data.Data.RegistrationType;
          verifyEmail();
        }
      } else {
        if(data.ErrorCode == '182'){
          $scope.alertError.message = 'Oops, this card has already been registered. Please try logging in.';
          $scope.alertError.resetPassword = true;
          $scope.alertError.show = true;
        } else {
          $scope.alertError.message = 'Oops, we were unable to register this card. Please verify the information is correct and try again at a later time.';
          $scope.alertError.show = true;
        }
      }
    }).catch(function(error){
      $scope.parent.fullOverlayLoading = false;
      $scope.alertError.message = 'Oops, we were unable to register this card. Please verify the information is correct and try again at a later time.';
      $scope.alertError.show = true;
    });
  };

  var defineRequest = function() {
    if ($scope.registrationVersion === 'CardID') {
      return {
        Email: $scope.formData.email,
        CardId: $scope.formData.CardID,
        _key: $scope.brand.api_key
      };
    } else {
      var exp = $scope.formData.exp;
      var expDate =  '20' + exp.split('/')[1] + exp.split('/')[0] + '30';

      if($scope.formData.countryCode == 'US') {
        $scope.formData.nra = 'N';
      }

      return {
        Email: $scope.formData.email,
        CardNumber: $scope.formData.cardNumber,
        ExpDate: expDate,
        CVV: $scope.formData.cvv,
        Employer: $scope.formData.employer,
        Occupation: $scope.formData.occupation,
        Country: $scope.formData.countryCode,
        NRA: $scope.formData.nra,
        PrimarySource: $scope.formData.primarySourceOfFunds,
        PrimaryUse: $scope.formData.primaryUseOfAccount,
        _key: $scope.brand.api_key
      };
    }
  };

  var registerSub = function(){
    $scope.parent.fullOverlayLoading = true;
    // Register sub-card request data
    var request = {
      _key: $scope.brand.api_key,
      CardNumber: $scope.formData.cardNumber,
      Email: $scope.formData.email,
      Password: $scope.formData.password,
      Pin: $scope.formData.pin,
    };

    $http({
      url: baseURI + 'sub-card/register',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function(resp){
      var data = resp.data;

      $scope.parent.fullOverlayLoading = false;
      if(data.Success){
        $scope.goToDashboard(data);
      } else {
        if(data.ErrorCode == '182'){
          $scope.alertError.message = 'Oops, this card has already been registered. Please try logging in.';
          $scope.alertError.resetPassword = true;
          $scope.alertError.show = true;
        } else {
          $scope.alertError.message = 'Oops, we were unable to register this card. Please verify the information is correct and try again at a later time.';
          $scope.alertError.show = true;
        }
      }
    }).catch(function(error){
      $scope.parent.fullOverlayLoading = false;
      $scope.alertError.message = 'Oops, we were unable to register this card. Please verify the information is correct and try again at a later time.';
      $scope.alertError.show = true;
    });

  };


  var registerCard = function(){
    $scope.parent.fullOverlayLoading = true;

    if($scope.formData.countryCode == 'US') {
      $scope.formData.nra = 'N';
    }

    var request = {
      _key: $scope.brand.api_key,
      Phone: $scope.formData.phone,
      Password: $scope.formData.password,
      Pin: $scope.formData.pin,
      FirstName: $scope.formData.firstName,
      LastName: $scope.formData.lastName,
      Email: $scope.formData.email,
      StreetAddress: $scope.formData.address,
      City: $scope.formData.city,
      State: $scope.formData.state,
      Zipcode: $scope.formData.zip,
      Employer: $scope.formData.employer,
      Occupation: $scope.formData.occupation,
      Country: $scope.formData.countryCode,
      NRA: $scope.formData.nra,
      PrimarySource: $scope.formData.primarySourceOfFunds,
      PrimaryUse: $scope.formData.primaryUseOfAccount,
      DeviceSessionID: sessionId
    };

    if ($scope.formData.address2) {
      request.SuiteNumber = $scope.formData.address2;
    }

    if ($scope.registrationVersion === 'CardID') {
      request.CardId = $scope.formData.CardID;
    } else {
      var exp = $scope.formData.exp;
      var expDate =  '20' + exp.split('/')[1] + exp.split('/')[0] + '30';
      request.CardNumber = $scope.formData.cardNumber;
      request.ExpDate = expDate;
      request.CVV = $scope.formData.cvv;
    }

    if($scope.validation.requiresKyc){
      var dobMonth = ($scope.formData.Dob1 < 10 ? ('0' + $scope.formData.Dob1) : $scope.formData.Dob1);
      var dobDay = ($scope.formData.Dob2 < 10 ? ('0' + $scope.formData.Dob2) : $scope.formData.Dob2);

      request.Ssn = $scope.formData.Ssn;
      request.Dob = dobMonth + '/' + dobDay + '/' + $scope.formData.Dob3;
    }

    $http({
      url: baseURI + 'card/register',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function(resp){
      var data = resp.data;

      var message = "";

      $scope.parent.fullOverlayLoading = false;
      if(data.Success){
        $scope.goToDashboard(data);
      } else {
        if(data.ErrorCode == '182'){
          message = 'Oops, this card has already been registered. Please log in to view this card.';
          goToLoginSuccessPage(message);
        }
        else if (data.ErrorCode === '100'){ // verification failure vendor
          switch(data.VendorErrorCode){
            case '1075':
              //need SSV
              message = "In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your Social Security Card or W-2 Form.";
              goToSuccessPage(message);
              break;
            case '1077':
              //bad Proof of Address
              message = "The address you entered could not be verified. In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload your proof of address.";
              goToSuccessPage(message);
              break;
            case '1050':
            case '1076':
              //need drivers license
              message = "We were unable to confirm some of the information you provided. In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your driver's license or government-issued ID card.";
              goToSuccessPage(message);
              break;
            case '965':
              $scope.alertError.message = 'Oops, looks like you have already signed up with an account.';
              $scope.alertError.resetPassword = true;
              $scope.alertError.show = true;
              break;
            case '942':
              $scope.alertError.message = 'Sorry, but we cannot ship cards to a P.O. Box. Please try again using a street address. Code 942.';
              $scope.alertError.show = true;
              $scope.$parent.validateAndSubmitBtn = true;
              $state.go('root.join.step2', {joinType: $scope.joinType});
              break;
            default:
              $scope.alertError.message = ENROLLMENT_ERROR[1] + data.VendorErrorCode;
              $scope.alertError.show = true;
              break;
          }
        }
        else {
          $scope.alertError.message = 'Oops, we were unable to register this card. Please verify the information is correct and try again at a later time.';
          $scope.alertError.show = true;
        }
      }
    }).catch(function(error){
      $scope.parent.fullOverlayLoading = false;

      if(error.data.ErrorCode == 150){ //fraud filter error. The user should only have the option to go to the dashboard.
        var message = "In order to better protect your identity, we require some documentation before we can open your account. Please continue to the account dashboard where you can upload an image of your driver's license or government-issued ID card.";
        goToSuccessPage(message);
        $scope.loading = false;
        return;
      }

      $scope.alertError.message = 'Oops, we were unable to register this card. Please verify the information is correct and try again at a later time.';
      $scope.alertError.show = true;
    });
  };

  $scope.updatePhone = function() {

  };

  // Verification email process
  var verifyEmail = function(){
    selectVerificationMethod();
  };

  // Prompt for verification method
  var selectVerificationMethod = function() {
    $scope.formData.updatedEmail = null;
    $scope.formData.verificationMethod = 'phone';

    $scope.verificationMethodChange = function(method) {
      $scope.formData.verificationMethod = method;
      $scope.verificationMethodIsPhone = $scope.formData.verificationMethod === 'phone';
      $scope.verificationMethodIsEmail = $scope.formData.verificationMethod === 'email';
    };

    // Default value
    $scope.verificationMethodChange('phone');

    // Open the modal
    $scope.showSelectVerificationMethod = true;
  };

  $scope.submitSelectVerificationMethod = function() {
    $scope.showSelectVerificationMethod = false;

    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.parent.fullOverlayLoading = true;
    var reqData = {
      VerificationType: $scope.formData.verificationMethod,
      Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : ($scope.formData.updatedEmail || $scope.formData.email),
      _key: $scope.brand.api_key
    };

    $http({
      url: baseURI + 'member/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function(resp){
      var data = resp.data;

      $scope.parent.fullOverlayLoading = false;
      if(data.Success){
        // Open the modal
        $scope.showValidateEmail = true;
        startCountDown();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
    }).catch(function(error){
      $scope.parent.fullOverlayLoading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
    });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        VerificationType: $scope.formData.verificationMethod,
        Contact: $scope.formData.verificationMethod === 'phone' ? $scope.formData.phone : ($scope.formData.updatedEmail || $scope.formData.email),
        VerificationCode: $scope.formData.VerificationCode
      };


      $http({
        url: baseURI + 'member/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  // Close the modal
  $scope.close = function(){
    if ($scope.showSelectVerificationMethod) {
      $scope.showSelectVerificationMethod = false;
    }
    else {
      $scope.stopTimeout();
      $scope.showValidateEmail = false;
    }
  };

  // User has successfully completed email verification
  var successVerfication = function(){
    $scope.$parent.verifiedEmail = true;
    $scope.showValidateEmail = false;

    switch ($scope.validation.RegistrationType){
      case 'login':
        $scope.validation.requiresKyc = false;
        $state.go('root.register.step3');
        break;
      case 'cardholder':
        $scope.validation.requiresKyc = false;
        $state.go('root.register.esignDisclosure');
        break;
      case 'cardholder-kyc':
        $scope.validation.requiresKyc = true;
        $state.go('root.register.esignDisclosure');
        break;
    }
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };

  };
}
]);
